<template>
    <div class="ml-10">
        <a-list item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta>
                    <div slot="title">
                        <h3 class="mt-10 mb-10" style="color: #610C9F !important;">
                            IC Meal
                        </h3>
                    </div>
                    <div slot="description">
                        
                    </div>
                    <a-avatar slot="avatar" shape="square" :size="55" src="imageApp/muic_pay_icon.png" />
                </a-list-item-meta>
            </a-list-item>
        </a-list>

        <div style="background-color: #F0F0F0;padding: 2px; border-radius: 10px;" class="mt-10 text-center">
            <h4 class="font-web mt-10 font-weight-bold">
                <span style="font-weight: 800;">ขั้นตอนการใช้ IC Meal</span>
            </h4>
            <p class="mt-5 mb-5 font-web">สวัสดิการเงินช่วยเหลือค่าอาหารรายเดือน โดยวิทยาลัย</p>
        </div>

        <a-row class="text-center" :gutter="[24, 16]">
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <MobileFrame title="Overview" name="bg-pay-01" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>เข้าใช้งาน</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <MobileFrame title="Overview" name="bg-pay-02" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>หน้าจอสำหรับ การจ่าย</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <MobileFrame title="Overview" name="bg-pay-03" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>สรุปผลการใช้งาน MUIC PAY</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
        </a-row>

        <div style="background-color: #F0F0F0;padding: 2px; border-radius: 10px;" class="mt-10 text-center">
            <h4 class="font-web mt-10 font-weight-bold">
                <span style="font-weight: 800;">ขั้นตอนการใช้ IC Meal</span>
            </h4>
            <p class="mt-5 mb-5 font-web">สวัสดิการเงินช่วยเหลือค่าอาหารรายเดือน โดยวิทยาลัย</p>
        </div>

        <a-row class="text-center mb-0">
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">1</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-pay-02" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>เปิดกล้อง</i></h5>
                        <p class="m-0 font-web"></p>
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">2</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-pay-04" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>สแกน Qr เพื่อทำการจ่าย</i></h5>
                        <p class="m-0 font-web"></p>
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">3</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-pay-05" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>ใส่ยอดเงิน</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">4</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-pay-06" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>ยืนยัน</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">5</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-pay-07" />
                    </template>
                    <template #title>
                        <h5 class="mt-50 mb-10 font-web"><i>ดำเนินการสำเร็จ</i></h5>
                        
                    </template>
                    
                </a-result>
            </a-col>
        </a-row>

        <div style="background-color: #F0F0F0;padding: 2px; border-radius: 10px;" class="mt-10 text-center">
            <h4 class="font-web mt-10 font-weight-bold">
                <span style="font-weight: 800;">ร้านค้าที่เข้าร่วมโครงการ</span>
            </h4>
            <p class="mt-5 mb-5 font-web">IC Meal (สวัสดิการเงินช่วยเหลือค่าอาหารรายเดือน โดยวิทยาลัย)</p>
        </div>

        <div class="mt-30 mb-30">
            <a-list class="mt-10" item-layout="vertical" size="small" :data-source="listData">
                <div class="font-web" slot="footer"><b>ร้านค้าที่เข้าโครงการ </b> {{ listData.length }} ร้าน</div>
                <a-list-item slot="renderItem" :key="item.id" slot-scope="item, index">
                    
                    <a-list-item-meta
                        :description="!['', null, 'null'].includes(item.detail) ? item.detail : `-`">
                        <h5 class="font-web mt-10" slot="title">{{ item.name }}</h5>
                        
                        <img class="mt-10" slot="avatar" style="width: 20vh;height: auto;" alt="imag_secPay_1"
                            :src="`https://my.muic.io${item.img_store}`" />
                    </a-list-item-meta>
                    {{ item.content }}
                </a-list-item>
            </a-list>
        </div>


    </div>
</template>

<script>
import moment from 'moment';
import MobileFrame from '../MobileFrame.vue';

export default {
    props: {
        listData: {
            type: Array,
            default: () => []
        }
    },
    components: {
        MobileFrame,
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
/* For demo */
.ant-carousel>>>.slick-slide {
    /* text-align: center;
    height: 160px;
    line-height: 160px;
    background: #ffffff; */
    overflow: hidden;
}

.ant-carousel>>>.custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
}

.ant-carousel>>>.custom-slick-arrow:before {
    display: none;
}

.ant-carousel>>>.custom-slick-arrow:hover {
    opacity: 0.5;
}

.ant-carousel>>>.slick-slide h3 {
    color: #fff;
}
</style>